// Vendor
import { type RouteLocationRaw } from "vue-router";

// Constants
import { SALESFORCE_FORM_TYPE } from "@citizenm/salesforce/constants/form";

// Types
import type { GenericState } from "@citizenm/foundation/shared/types/constants";

export default function useSalesforceForm(
  formType: (typeof SALESFORCE_FORM_TYPE)[keyof typeof SALESFORCE_FORM_TYPE] = SALESFORCE_FORM_TYPE.webToLead,
  thankYouPage?: RouteLocationRaw,
) {
  const { push: pushRoute } = useRouter();

  const state = ref<GenericState>("idle");

  async function handleSubmit(values: Record<string, unknown>) {
    state.value = "processing";

    try {
      await $fetch(`/api/salesforce/form/${formType}`, {
        method: "POST",
        body: values,
      });

      state.value = "success";

      if (thankYouPage) {
        await pushRoute(thankYouPage);
      }
    } catch (error) {
      state.value = "error";
    }
  }

  return {
    handleSubmit,
    state,
  };
}
